var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row mb-24" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center tag tag-sm mb-8 mr-8" },
        [
          _c("i", {
            staticClass: "mr-8 filter-icon",
            domProps: { innerHTML: _vm._s(_vm.svg("filter")) }
          }),
          _c(
            "small",
            { staticClass: "d-none d-md-block text-accent font-weight-light" },
            [_vm._v("Filter")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tag-row align-items-center" },
        _vm._l(_vm.locationCategories, function(category) {
          return _c(
            "div",
            { key: category.id, staticClass: "tag-col d-flex" },
            [
              _c("a", {
                staticClass: "tag tag-sm mb-8",
                class: _vm.activeCategories.includes(category.term_id)
                  ? "tag-accent"
                  : "tag-accent-light",
                domProps: { innerHTML: _vm._s(category.name) },
                on: {
                  click: function($event) {
                    return _vm.toggleCategory(category)
                  }
                }
              })
            ]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row mb-n24" },
      _vm._l(_vm.visibleLocations, function(location) {
        return _c(
          "div",
          { staticClass: "col-12 col-md-6 col-xl-4 mb-24" },
          [_c("location-card", { attrs: { location: location } })],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }